<template>
  <div class="node-tree-item" :style="{ paddingLeft: depth * 28 + 'px' }">
    <div class="node-card" :class="'depth-' + depth">
      <div class="node-card-inner">
        <!-- toggle expand -->
        <button
          v-if="hasChildren"
          class="btn-toggle"
          @click="expanded = !expanded"
        >
          <i
            :class="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"
            style="font-size: 11px"
          />
        </button>
        <div v-else class="btn-toggle-placeholder" />

        <!-- ícone do tipo -->
        <div
          class="node-icon"
          :style="{ background: categoryColor + '20', color: categoryColor }"
        >
          <feather-icon :icon="categoryIcon" size="18" />
        </div>

        <!-- info -->
        <div class="node-info">
          <div class="node-name">{{ node.name }}</div>
          <div class="node-meta">
            <span
              class="badge-type"
              :style="{
                background: categoryColor + '20',
                color: categoryColor,
              }"
            >
              {{ node.type ? node.type.name : $t('node.treeItem.noType') }}
            </span>
            <span
              class="meta-item"
              v-if="node.children && node.children.length"
            >
              <i class="fas fa-sitemap" style="font-size: 10px" />
              {{
                node.children.length > 1
                  ? $t('node.treeItem.subNodesCountPlural', { count: node.children.length })
                  : $t('node.treeItem.subNodesCountSingular', { count: node.children.length })
              }}
            </span>
          </div>
        </div>

        <!-- ações -->
        <div v-if="$hasAbility('node.admin')" class="node-actions">
          <button
            class="btn btn-sm btn-icon btn-flat-primary"
            :title="$t('node.actions.administer')"
            @click="$emit('admin', node)"
          >
            <feather-icon icon="SettingsIcon" size="15" />
          </button>
          <button
            class="btn btn-sm btn-icon btn-flat-secondary"
            :title="$t('common.edit')"
            @click="$emit('edit', node)"
          >
            <feather-icon icon="EditIcon" size="15" />
          </button>
          <button
            class="btn btn-sm btn-icon btn-flat-danger"
            :title="$t('common.delete')"
            @click="$emit('delete', node)"
          >
            <feather-icon icon="Trash2Icon" size="15" />
          </button>
        </div>
      </div>
    </div>

    <!-- filhos recursivos -->
    <template v-if="hasChildren && expanded">
      <node-tree-item
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :depth="depth + 1"
        @admin="$emit('admin', $event)"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "NodeTreeItem",
  props: {
    node: { type: Object, required: true },
    depth: { type: Number, default: 0 },
  },
  data() {
    return { expanded: true };
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    categoryIcon() {
      if (!this.node.type) return "CircleIcon";
      const cat = this.node.type.category;
      if (cat === "team") return "UsersIcon";
      if (cat === "professional") return "UserIcon";
      return "GitBranchIcon";
    },
    categoryColor() {
      if (!this.node.type) return "#6c757d";
      const cat = this.node.type.category;
      if (cat === "team") return "#28c76f";
      if (cat === "professional") return "#00cfe8";
      return "#7367f0";
    },
  },
};
</script>

<style scoped>
.node-tree-item {
  position: relative;
}

.node-card {
  position: relative;
}

.node-card-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 12px;
  transition: box-shadow 0.15s, border-color 0.15s;
  margin-bottom: 4px;
}

.node-card-inner:hover {
  border-color: #7367f0;
  box-shadow: 0 2px 10px rgba(115, 103, 240, 0.12);
}

.depth-0 .node-card-inner {
  border-left: 4px solid #7367f0;
}
.depth-1 .node-card-inner {
  border-left: 4px solid #28c76f;
}
.depth-2 .node-card-inner {
  border-left: 4px solid #00cfe8;
}
.depth-3 .node-card-inner {
  border-left: 4px solid #ff9f43;
}

.btn-toggle {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  width: 20px;
  padding: 0;
  flex-shrink: 0;
}

.btn-toggle-placeholder {
  width: 20px;
  flex-shrink: 0;
}

.node-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.node-info {
  flex: 1;
  min-width: 0;
}

.node-name {
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  flex-wrap: wrap;
}

.badge-type {
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 600;
}

.meta-item {
  font-size: 0.75rem;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 4px;
}

.node-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.15s;
}

.node-card-inner:hover .node-actions {
  opacity: 1;
}

.btn-icon {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
</style>
